import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';
import {
  NotificationsProvider,
  useNotifyFactory,
} from 'app/common/notifications/features/notifications';
import { PageContent } from 'app/ui';

import { AddTerminal } from '../features/add-terminal';

export const AddTerminalPage = observer(() => {
  const notify = useNotifyFactory();

  return (
    <NotificationsProvider value={notify}>
      <AppPage perm="PERM_TERMINAL_CREATE">
        <PageContent>
          <AddTerminal />
        </PageContent>
      </AppPage>
    </NotificationsProvider>
  );
});
